import { cv } from '~/lib/cv-bridge';

/**
 * Run normalised cross-correlation of `patch` against `frameImg`, anchored at
 * `prevOffset` with a ±searchRadius window. Returns the frame translation
 * needed to move the matched point back to `prevOffset`, plus confidence in
 * [0, 1]. Out-of-window peaks return
 * `{dx: 0, dy: 0, confidence: 0}`.
 */
export function templateMatchViaWorker(
  frameImg: ImageData,
  patch: ImageData,
  prevOffset: { x: number; y: number },
  searchRadius: number,
): Promise<{ dx: number; dy: number; confidence: number }> {
  return cv.get().templateMatch(frameImg, patch, prevOffset, searchRadius);
}
